import { AclRule } from "vue-acl";

import DashView from "./components/Dash.vue";
import LoginView from "./components/Login.vue";
import NotFoundView from "./components/404.vue";

import DashboardView from "./components/dashboard/Dashboard.vue";

/* Garantias Components */
import GarantiaIndex from "./components/operacao/garantias";
import GarantiaDetalhe from "./components/operacao/garantias/detalhe";
import GarantiaNova from "./components/operacao/garantias/nova";
import GarantiaImpressaoBoleto from "./components/operacao/garantias/impressao";
import GarantiaImpressaoDetalhe from "./components/operacao/garantias/impressaoDetalhe";

/* Cobranças Components */
import InadimplenteIndex from "./components/cobranca/inadimplentes/inadimplentes";
import InadimplenteDetalhe from "./components/cobranca/inadimplentes/inadimplenteDetalhe";
import AgendamentoIndex from "./components/cobranca/agendamentos/agendamentos";
import AcordosIndex from "./components/cobranca/acordos/acordos";

/* Empresas Components */
import EmpresaList from "./components/administracao/empresas";
import EmpresaForm from "./components/administracao/empresas/form";

/* Pessoa Components */
import PessoaIndex from "./components/administracao/pessoas";
import PessoaForm from "./components/administracao/pessoas/form";

/* Users Components */
import UserList from "./components/administracao/usuarios";
import UserForm from "./components/administracao/usuarios/form.vue";
import UserFormAlterarSenha from "./components/administracao/usuarios/formAlterarSenha.vue";

/* Remessas Components */
import RemessaIndex from "./components/operacao/remessas";

/* Retorno Components */
import RetornoIndex from "./components/operacao/retornos";

/* Recebimentos Components */
import RecebimentoIndex from "./components/financeiro/recebimentos";

/* Boletos Components */
import BoletoIndex from "./components/financeiro/boletos";

/* Boletos Avulsos Components */
import BoletoAvulsoIndex from "./components/financeiro/avulsos";
import BoletoAvulsoForm from "./components/financeiro/avulsos/form";

/* Relatórios Components */
import FechamentoIndex from "./components/financeiro/relatorios/fechamento";
import FaturamentoIndex from "./components/financeiro/relatorios/faturamento";

/* Antecipação Components */
import AntecipacaoIndex from "./components/operacao/antecipacao";
import AntecipacaoForm from "./components/operacao/antecipacao/form";
import AntecipacaoSimulador from "./components/operacao/antecipacao/simuladorVenda";

/* Rotas */
const routes = [{
        path: "/login",
        component: LoginView,
        meta: {
            rule: new AclRule("public").generate()
        }
    },
    {
        path: "/",
        component: DashView,
        meta: {
            requiresAuth: true,
            rule: new AclRule('usuario').or('administrador').generate()
        },
        children: [{
                path: "dashboard",
                alias: "",
                component: DashboardView,
                name: "Boleto Web",
                meta: {
                    description: "Início",
                    rule: new AclRule('usuario').or('administrador').generate()
                }
            },
            /* GARANTIAS ROUTES */
            {
                path: "operacao/garantias/nova",
                component: GarantiaNova,
                name: "Boleto Web",
                meta: {
                    description: "Solicitação de Garantia",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "operacao/garantias",
                component: GarantiaIndex,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Garantias",
                    rule: new AclRule('administrador').generate()
                }
            },
            {
                path: "operacao/garantias/detalhe/:garantiaId",
                component: GarantiaDetalhe,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Garantias",
                    rule: new AclRule('administrador').generate()
                }
            },
            {
                path: "operacao/garantias/impressao",
                component: GarantiaImpressaoBoleto,
                name: "Boleto Web",
                meta: {
                    description: "Impressão de Boletos",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "operacao/garantias/impressao/detalhe/:garantiaId",
                component: GarantiaImpressaoDetalhe,
                name: "Boleto Web",
                meta: {
                    description: "Impressão de Boletos",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },

            {
                path: "operacao/antecipacoes",
                component: AntecipacaoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Antecipações de Garantia",
                    rule: new AclRule('administrador').or('usuario').generate()
                }
            },

            {
                path: "operacao/antecipacoes/nova",
                component: AntecipacaoForm,
                name: "Boleto Web",
                meta: {
                    description: "Antecipações de Garantia",
                    rule: new AclRule('administrador').or('usuario').generate()
                }
            },

						{
							path: "operacao/antecipacoes/simular-venda",
							component: AntecipacaoSimulador,
							name: "Boleto Web",
								meta: {
										description: "Simulador de venda com taxas",
										rule: new AclRule('administrador').or('usuario').generate()
								}
						},

            /* COBRANÇAS ROUTES */
            {
                path: "cobranca/inadimplentes",
                component: InadimplenteIndex,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Inadimplentes",
                    rule: new AclRule("administrador").generate()
                }
            },
            {
                path: "cobranca/inadimplentes/detalhe/:inadimplenteId",
                component: InadimplenteDetalhe,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Garantias",
                    rule: new AclRule('administrador').generate()
                }
            },
            {
                path: "cobranca/agendamentos",
                component: AgendamentoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Agendamentos",
                    rule: new AclRule("administrador").generate()
                }
            },
            {
                path: "cobranca/acordos",
                component: AcordosIndex,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Acordos",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* REMESSA ROUTES */
            {
                path: "operacao/remessas",
                component: RemessaIndex,
                name: "Boleto Web",
                meta: {
                    description: "Remessas",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* RETORNO ROUTES */
            {
                path: "operacao/retornos",
                component: RetornoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Retornos",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* RECEBIMENTOS ROUTES */
            {
                path: "financeiro/recebimentos",
                component: RecebimentoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Recebimentos",
                    rule: new AclRule("usuario").or("administrador").generate()
                }
            },

            /* BOLETOS ROUTES */
            {
                path: "financeiro/boletos",
                component: BoletoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Boletos Garantidos",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* BOLETOS AVULSOS */
            {
                path: "financeiro/boletos-avulsos",
                component: BoletoAvulsoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Boletos Avulsos",
                    rule: new AclRule("administrador").generate()
                }
            },
            {
                path: "financeiro/boletos-avulsos/novo",
                component: BoletoAvulsoForm,
                name: "Boleto Web",
                meta: {
                    description: "Novo Boleto Avulso",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* RELATÓRIOS ROUTES */
            {
                path: "financeiro/relatorios/faturamento",
                component: FaturamentoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Relatório de Faturamento",
                    rule: new AclRule("administrador").generate()
                }
            },
            {
                path: "financeiro/relatorios/fechamento",
                component: FechamentoIndex,
                name: "Boleto Web",
                meta: {
                    description: "Relatório de Fechamento",
                    rule: new AclRule("administrador").generate()
                }
            },

            /* EMPRESAS ROUTES */
            {
                path: "administracao/empresas",
                component: EmpresaList,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Empresas",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "administracao/empresas/nova",
                component: EmpresaForm,
                name: "Boleto Web",
                meta: {
                    description: "Nova Empresa",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "administracao/empresas/atualizacao/:idEmpresa",
                component: EmpresaForm,
                name: "Boleto Web",
                meta: {
                    description: "Atualização da Empresa",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },

            /* PESSOA ROUTES */
            {
                path: "administracao/pessoas",
                component: PessoaIndex,
                name: "Boleto Web",
                meta: {
                    description: "Gerenciamento de Pessoas",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
						{
							path: "administracao/pessoas/atualizacao/:idPessoa",
							component: PessoaForm,
							name: "Boleto Web",
							meta: {
									description: "Atualização da Pessoa",
									rule: new AclRule("usuario").or('administrador').generate()
							}
					},

            /* USERS ROUTES */
            {
                path: "administracao/usuarios",
                component: UserList,
                name: "Boleto Web",
                meta: {
                    description: "Usuários do Sistema",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "administracao/usuarios/novo",
                component: UserForm,
                name: "Boleto Web",
                meta: {
                    description: "Novo Usuário",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "administracao/usuarios/atualizacao/:idUsuario",
                component: UserForm,
                name: "Boleto Web",
                meta: {
                    description: "Atualização do Usuário",
                    rule: new AclRule("usuario").or('administrador').generate()
                }
            },
            {
                path: "administracao/usuarios/alterarSenha",
                component: UserFormAlterarSenha,
                name: "Boleto Web",
                meta: {
                    description: "Alterar Senha",
                    rule: new AclRule("usuario").or("administrador").generate()
                }
            }
        ]
    },
    {
        // not found handler
        path: "*",
        component: NotFoundView,
        meta: {
            description: "Error",
            rule: new AclRule("public").generate()
        }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js